import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { form: String }

  submit(_event) {
    const form = this.formValue
      ? document.getElementById(this.formValue)
      : this.element
    if (form?.requestSubmit) {
      form.requestSubmit()
    } else {
      form?.submit()
    }
  }
}
